// @tennis-matches/services/governance
// Alter des eingeloggten Nutzers für Marketplace (club_people per Auth-E-Mail).

import { getSupabaseClient, getSupabaseUser } from "../supabase/index.js";
import { getAgeVerificationStatus } from "../trainerstunden/age-verification.js";

const RPC_KEY = "rpc:get_my_marketplace_person_age";

function __asStr(v) {
  return String(v ?? "").trim();
}

/**
 * @returns {Promise<{ ok: boolean, ageStatus?: 'adult'|'minor'|'unknown', person?: object|null, reason?: string }>}
 */
export async function loadMyMarketplacePersonAgeRemote() {
  try {
    const supabase = await getSupabaseClient();
    if (!supabase) return { ok: false, reason: "no-supabase", ageStatus: "unknown" };

    const user = await getSupabaseUser();
    const email = __asStr(user?.email).toLowerCase();
    if (!email) return { ok: false, reason: "no-email", ageStatus: "unknown" };

    const { data, error } = await supabase.rpc("get_my_marketplace_person_age");
    if (!error && data && typeof data === "object") {
      if (data.ok === false) {
        return { ok: false, reason: __asStr(data.reason) || "rpc-not-ok", ageStatus: "unknown" };
      }
      const person = {
        birth_date: data.birthDate ?? data.birth_date ?? null,
        birth_year: data.birthYear ?? data.birth_year ?? null,
      };
      const ageStatus = __asStr(data.ageStatus) || getAgeVerificationStatus(person);
      return { ok: true, ageStatus, person };
    }

    if (error) {
      const code = __asStr(error?.code);
      if (code === "42883" || code === "PGRST202") {
        return { ok: true, ageStatus: "unknown", person: null, reason: RPC_KEY };
      }
    }

    return { ok: true, ageStatus: "unknown", person: null };
  } catch (e) {
    return { ok: false, reason: String(e?.message || e), ageStatus: "unknown" };
  }
}
